import { all, fork } from "redux-saga/effects";
import userAuth from "./userAuthSaga";
import userRegistrationSaga from "./userRegistrationSaga";
import adminSaga from "./adminSaga";
import doctorSaga from "./doctorSaga";
import patientSaga from "./patientSaga";
import appointmentSaga from "./appointmentSaga";
import dynamicFormSaga from "./dynamicFormSaga";
import documentSaga from "./documentSaga";

//import organize from './organize/organize';

export default function* rootSaga() {
  yield all([
    fork(dynamicFormSaga),
    fork(userAuth),
    fork(userRegistrationSaga),
    fork(adminSaga),
    fork(doctorSaga),
    fork(patientSaga),
    fork(appointmentSaga),
    fork(documentSaga),
  ]);
}
